import { Box, Container, Flex, Text, Image, Icon, Input, Button, CircularProgress, FormLabel, FormControl } from '@chakra-ui/react'
import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { toast } from 'react-toastify'
import { ActionMenu } from '../../components/ActionMenu/ActionMenu';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ListForSaleModal } from '../../components/ListForSale/ListForSaleModal';
import { BuyNftModal } from '../../components/BuyNft/BuyNftModal';
import { MarketplaceUtils, TokenUtils } from '../wallet';
import { getNftDetailApi } from '../../setup/api/apiNftDetail';
import { NftDetailType, PricePurchaseType, StakingHistory } from '../../models/NftType';
import { minify } from '../../helpers/crud-helper/helpers';
import { useChainId, useSigner, useSwitchChain } from '@thirdweb-dev/react';
import { WalletContext } from '../wallet/walletContext';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import { fetchUserProfile } from '../../components/ProfilePage/userProfileSlice';
import { getNFTsByCollection } from '../../components/CollectionPage/nftsCollectionSlice';
import { MoreNft } from '../../components/NftDetailPage/MoreNft';
import { IDS, MARKETPLACE_CONTRACT_ADDRESS, MARKETPLACE_SUPPORT_NETWORK, STAKING_STATUS, URL_COLLECTION_DEFAULT, USDT_DECIMALS, chainIds } from '../../constants';
import { BigNumber, ethers } from 'ethers';
import { saveBuyerNftApi } from '../../setup/api/apiSaveBuyerNft';
import { cancelListingNftApi } from '../../setup/api/apiListingNft';
import moment from 'moment'
import { formatDistance, parseISO } from 'date-fns';
import { enUS, ja } from 'date-fns/locale';
import { useLang } from '../../i18/I18nContext';
import { checkReferralCodeApi } from '../../setup/api/apiUser';
import { getPriceUsdApi } from '../../setup/api/apiGetPriceUsd';
import { syncOwnersNftApi } from '../../setup/api/apiSync';
import { saveTransactionLogApi } from '../../setup/api/apiSaveTransactionLog';
export const NftDetailPage = () => {
    const intl = useIntl();
    const location = useLocation()
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const { selectedLang } = useLang()

    const goBack = () => {
        navigate(-1)
    }

    const localeMap: { [key: string]: any } = {
        'en': enUS,
        'ja': ja
    };

    const { isLogin, setOpenModalLogin, tokenExpiredCb, walletAddress } = useContext(WalletContext)
    const { data: userData } = useAppSelector((state) => state.userProfile)

    const { network, contractId, tokenId } = useParams()

    const handleCopy = (data: string) => {
        navigator.clipboard.writeText(data)
        toast.success(intl.formatMessage({ id: 'UTIL.COPIED' }), { closeButton: false, })
    }

    const [openModalListForSale, setOpenModalListForSale] = useState(false)
    const [openModalBuyNft, setOpenModalBuyNft] = useState(false)
    const [reloadData, setReloadData] = useState(false)

    const handleReloadData = () => {
        setReloadData(!reloadData)
        setLoaddingListing(false)
    }

    const onCloseModalListForSale = () => {
        setOpenModalListForSale(false)
        setLoaddingListing(false)
    }
    const onCloseModalBuyNft = () => {
        setOpenModalBuyNft(false)
    }

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [location?.pathname])

    const [nftInformation, setNftInformation] = useState<NftDetailType>()

    useEffect(() => {
        if (!network || !contractId || !tokenId) return
        (async () => {
            const res = await getNftDetailApi({
                network: network,
                contractAddress: contractId,
                tokenId: tokenId
            })
            if (!res) {
                navigate('/')
                return
            }
            setNftInformation(res)

        })()
    }, [network, contractId, tokenId, reloadData])


    useEffect(() => {
        if (isLogin && walletAddress) {
            dispatch(fetchUserProfile(tokenExpiredCb))
            return
        }
    }, [isLogin, walletAddress])


    const [moreNftForCollection, setMoreNftForCollection] = useState<NftDetailType[]>()

    useEffect(() => {
        if (!nftInformation?.owner?.[0] || !userData?.walletAddress || nftInformation?.owner?.[0]?.toLocaleLowerCase() !== userData?.walletAddress?.toLocaleLowerCase()) return
        (async () => {
            const res = await getNFTsByCollection({
                contractAddress: contractId,
                network: network,
                isAll: true
            })
            setMoreNftForCollection(res?.data?.data)
        })()
    }, [nftInformation?.owner?.[0], userData?.walletAddress])

    const signer = useSigner()
    const chain = useChainId()
    const switchChain = useSwitchChain()

    const [referralCode, setReferralCode] = useState<string>('')
    const [loadingBuying, setLoadingBuying] = useState(false)
    const [pricePurchase, setPricePurchase] = useState<PricePurchaseType>({ subTotal: 0, gasFee: 0, totalPrice: 0 })

    const handleLogicOpenBuyModal = async () => {
        if (!isLogin) {
            setOpenModalLogin(true)
            localStorage.setItem('redirectPath', location?.pathname)
        } else {
            if (!signer || !userData?.walletAddress || !network || !nftInformation?.setting) return
            if (!referralCode) {
                toast?.error(intl.formatMessage({ id: 'NFT.REFERRAL.CODE.ISREQUIRED' }), { closeButton: false, })
                return
            }
            setLoadingBuying(true)
            //check referralCode

            if (referralCode) {
                const checkreferralCode = await checkReferralCodeApi({ referralCode })
                if (!checkreferralCode?.data?.isValid) {
                    setOpenModalBuyNft(false)
                    setLoadingBuying(false)
                    toast?.error(intl.formatMessage({ id: 'NFT.REFERRAL.CODE.INVALID' }), { closeButton: false, })
                    return
                }
            }

            // save transaction log
            const resultForSaveTransactionLog = await saveTransactionLogApi({
                network: network,
                contractAddress: nftInformation?.contractAddress,
                tokenId: nftInformation?.tokenId,
                marketplaceContractAddress: MARKETPLACE_CONTRACT_ADDRESS,
                referralCode: referralCode,
            })
            if (!resultForSaveTransactionLog?.data?.success) {
                setLoadingBuying(false)
                toast?.error(intl.formatMessage({ id: 'NFT.BUY.SAVE.TRANSACTION.LOG.ERROR' }), { closeButton: false, })
                return
            }

            //switchChain
            if (chainIds[network] !== chain) {
                await switchChain(chainIds[network])
            }

            try {
                const allowance = await TokenUtils.allowance(network, nftInformation?.setting?.currencyAddress, userData?.walletAddress, MARKETPLACE_CONTRACT_ADDRESS)
                if (allowance?.lt(ethers.utils.parseUnits(nftInformation?.setting?.price?.toString(), USDT_DECIMALS))) {
                    await TokenUtils?.approve(signer, nftInformation?.setting?.currencyAddress, MARKETPLACE_CONTRACT_ADDRESS, ethers.utils.parseUnits(nftInformation?.setting?.price?.toString(), USDT_DECIMALS))
                }
                const result = await MarketplaceUtils?.buyFromListing(
                    signer,
                    MARKETPLACE_CONTRACT_ADDRESS,
                    nftInformation?.setting?.listingId,
                    userData?.walletAddress,
                    nftInformation?.setting?.quantity,
                    nftInformation?.setting?.currencyAddress,
                    ethers?.utils.parseUnits(String(nftInformation?.setting?.price), USDT_DECIMALS)
                )

                //api save buyer
                if (result?.receipt.status) {

                    await saveBuyerNftApi({
                        network: network,
                        contractAddress: nftInformation?.contractAddress,
                        tokenId: nftInformation?.tokenId,
                        transactionHash: result?.receipt.transactionHash,
                        marketplaceContractAddress: MARKETPLACE_CONTRACT_ADDRESS,
                        referralCode: referralCode,
                    })
                    setPricePurchase({ subTotal: nftInformation?.setting?.price, gasFee: Number(ethers.utils.formatEther(result?.receipt?.effectiveGasPrice)), totalPrice: nftInformation?.setting?.price + Number(ethers.utils.formatEther(result?.receipt?.effectiveGasPrice)) })
                    toast?.success(intl.formatMessage({ id: 'NFT.BUY.SUCCESS' }), { closeButton: false, })
                    setOpenModalBuyNft(true)
                    setLoadingBuying(false)
                    handleReloadData()
                }

            } catch (error: any) {
                setOpenModalBuyNft(false)
                setLoadingBuying(false)
                if (error?.reason) {
                    toast?.error(error?.reason || 'unknown error')
                    return
                }
                toast?.error('error')
                return
            }
        }
    }

    const [loaddingCancelListing, setLoaddingCancelListing] = useState(false)

    const handleCancelListing = async () => {
        if (!signer || !network || !nftInformation?.setting) return
        setLoaddingCancelListing(true)

        //switchChain

        if (chainIds[network] !== chain) {
            await switchChain(chainIds[network])
        }

        try {
            const result = await MarketplaceUtils?.cancelListing(signer, MARKETPLACE_CONTRACT_ADDRESS, nftInformation?.setting?.listingId)

            if (result?.receipt.status) {
                await cancelListingNftApi({
                    network: network,
                    contractAddress: nftInformation?.contractAddress,
                    tokenId: nftInformation?.tokenId
                })
                toast?.success(intl.formatMessage({ id: 'NFT.LISTING.CANCEL' }), { closeButton: false, })
                handleReloadData()
                setLoaddingCancelListing(false)
            } else {
                toast?.error('error')
                setLoaddingCancelListing(false)
            }
        } catch (error: any) {
            setLoaddingCancelListing(false)
            if (error?.reason) {
                toast?.error(error?.reason || 'unknown error')
                return
            }
            toast?.error('error')
            return
        }
    }

    const [loaddingListing, setLoaddingListing] = useState(false)

    const handleListing = () => {
        setOpenModalListForSale(true)
        setLoaddingListing(true)
    }

    const [priceUsd, setPriceUsd] = useState(0)

    useEffect(() => {
        if (!network) return
        const fetchPrice = async () => {
            try {
                const response = await getPriceUsdApi({ ids: IDS[network], vs_currencies: 'usd' })

                setPriceUsd(response?.[IDS[network]]?.usd)
            } catch (error) {
                console.error('Error fetching price:', error)
            }
        };

        fetchPrice()
    }, [network]);

    const getHighestStaking = (stakingHistory: StakingHistory[]): StakingHistory | undefined => {
        let highestStaking: StakingHistory | undefined = undefined;
        if (stakingHistory.length === 0) return highestStaking;

        highestStaking = stakingHistory[0]

        for (const item of stakingHistory) {
            if (!highestStaking.stakingId || item.stakingId > highestStaking.stakingId) {
                highestStaking = item;
            }
        }

        return highestStaking;
    };

    const highestStaking: StakingHistory | undefined = nftInformation?.stakingHistory ? getHighestStaking(nftInformation.stakingHistory) : undefined;

    const syncCollection = async () => {
        if (!network || !isLogin || !contractId || !tokenId) return
        const syncData = await syncOwnersNftApi({ network: network, contractAddress: contractId, tokenId, tokenExpiredCb })
        if (syncData?.data?.success) {
            toast.success(intl.formatMessage({ id: 'PROFILE.SYNC.SUCCESS' }))
        }
    }

    useEffect(() => {
        if (isLogin && userData?.appliedCode) {
            setReferralCode(userData.appliedCode)
        } else {
            setReferralCode('')
        }
    }, [isLogin, userData?.appliedCode])

    return (
        <Container maxW={{ xxl: 1400, xl: 1200, lg: 960, md: 768, sm: 480, base: 390 }} margin={'0 auto'} p={0}>
            <Flex w={'100%'} flexWrap={'wrap'}>
                <Box position={'relative'} w={{ lg: '70%', base: '100%' }} px={{ base: 0, lg: '104px' }} py={{ base: '16px', lg: '40px' }} mb={{ base: '8px', lg: 0 }}>
                    <Box onClick={goBack} display={{ lg: 'flex', base: 'none' }} position={'absolute'} left={0} top={{ base: '16px', lg: '40px' }} cursor={'pointer'} justifyContent={'center'} alignItems={'center'} borderRadius={'50%'} bg={'#1C1F22'} w={'48px'} h={'48px'}>
                        <Icon display={'block'} h={'24px'} w={'24px'} viewBox="0 0 24 24" fill="none" color="#515458">
                            <path d="M21 12.0004C21 12.1993 20.921 12.3901 20.7803 12.5307C20.6397 12.6714 20.4489 12.7504 20.25 12.7504H5.56029L11.0306 18.2198C11.1003 18.2895 11.1556 18.3722 11.1933 18.4632C11.231 18.5543 11.2504 18.6519 11.2504 18.7504C11.2504 18.849 11.231 18.9465 11.1933 19.0376C11.1556 19.1286 11.1003 19.2114 11.0306 19.281C10.9609 19.3507 10.8782 19.406 10.7872 19.4437C10.6961 19.4814 10.5985 19.5008 10.5 19.5008C10.4014 19.5008 10.3039 19.4814 10.2128 19.4437C10.1218 19.406 10.039 19.3507 9.96935 19.281L3.21935 12.531C3.14962 12.4614 3.0943 12.3787 3.05656 12.2876C3.01882 12.1966 2.99939 12.099 2.99939 12.0004C2.99939 11.9019 3.01882 11.8043 3.05656 11.7132C3.0943 11.6222 3.14962 11.5394 3.21935 11.4698L9.96935 4.71979C10.1101 4.57906 10.301 4.5 10.5 4.5C10.699 4.5 10.8899 4.57906 11.0306 4.71979C11.1713 4.86052 11.2504 5.05139 11.2504 5.25042C11.2504 5.44944 11.1713 5.64031 11.0306 5.78104L5.56029 11.2504H20.25C20.4489 11.2504 20.6397 11.3294 20.7803 11.4701C20.921 11.6107 21 11.8015 21 12.0004Z" fill="white" />
                        </Icon>
                    </Box>
                    <Image
                        borderRadius={'6px'}
                        objectFit={'cover'} w={'100%'}
                        h={{ base: '358px', lg: '600px' }}
                        src={nftInformation?.image?.includes('ipfs.io') ? nftInformation?.image?.replace('ipfs.io', 'cloudflare-ipfs.com') : nftInformation?.image ?? URL_COLLECTION_DEFAULT}
                    />
                </Box>
                <Box w={{ lg: '30%', base: '100%' }} py={{ base: 0, lg: '40px' }}>
                    <Flex justify={'space-between'} mb={'24px'}>
                        <Flex w={'100%'} align={'center'} justify={'start'}>
                            <Image
                                borderRadius={'6px'}
                                objectFit={'contain'}
                                h={{ base: '32px', lg: '40px' }}
                                w={{ base: '32px', lg: '40px' }}
                                src={nftInformation?.collection?.logo ?? URL_COLLECTION_DEFAULT}
                            />
                            <Text px={'9px'} fontSize={{ base: '12px', lg: '16px' }} fontWeight={700} noOfLines={1} title={nftInformation?.collection?.name}>{nftInformation?.collection?.name}</Text>
                            <Flex align={'center'} justify={'center'}>
                                <Icon h={'14px'} w={'14px'} viewBox='0 0 14 14' fill="none" color='white'>
                                    <path d="M14.1163 6.42625C13.8806 6.18 13.6369 5.92625 13.545 5.70312C13.46 5.49875 13.455 5.16 13.45 4.83187C13.4406 4.22187 13.4306 3.53062 12.95 3.05C12.4694 2.56937 11.7781 2.55937 11.1681 2.55C10.84 2.545 10.5013 2.54 10.2969 2.455C10.0744 2.36312 9.82 2.11937 9.57375 1.88375C9.1425 1.46937 8.6525 1 8 1C7.3475 1 6.85812 1.46937 6.42625 1.88375C6.18 2.11937 5.92625 2.36312 5.70312 2.455C5.5 2.54 5.16 2.545 4.83187 2.55C4.22187 2.55937 3.53062 2.56937 3.05 3.05C2.56937 3.53062 2.5625 4.22187 2.55 4.83187C2.545 5.16 2.54 5.49875 2.455 5.70312C2.36312 5.92562 2.11937 6.18 1.88375 6.42625C1.46937 6.8575 1 7.3475 1 8C1 8.6525 1.46937 9.14187 1.88375 9.57375C2.11937 9.82 2.36312 10.0737 2.455 10.2969C2.54 10.5013 2.545 10.84 2.55 11.1681C2.55937 11.7781 2.56937 12.4694 3.05 12.95C3.53062 13.4306 4.22187 13.4406 4.83187 13.45C5.16 13.455 5.49875 13.46 5.70312 13.545C5.92562 13.6369 6.18 13.8806 6.42625 14.1163C6.8575 14.5306 7.3475 15 8 15C8.6525 15 9.14187 14.5306 9.57375 14.1163C9.82 13.8806 10.0737 13.6369 10.2969 13.545C10.5013 13.46 10.84 13.455 11.1681 13.45C11.7781 13.4406 12.4694 13.4306 12.95 12.95C13.4306 12.4694 13.4406 11.7781 13.45 11.1681C13.455 10.84 13.46 10.5013 13.545 10.2969C13.6369 10.0744 13.8806 9.82 14.1163 9.57375C14.5306 9.1425 15 8.6525 15 8C15 7.3475 14.5306 6.85812 14.1163 6.42625ZM10.8538 6.85375L7.35375 10.3538C7.30731 10.4002 7.25217 10.4371 7.19147 10.4623C7.13077 10.4874 7.06571 10.5004 7 10.5004C6.93429 10.5004 6.86923 10.4874 6.80853 10.4623C6.74783 10.4371 6.69269 10.4002 6.64625 10.3538L5.14625 8.85375C5.05243 8.75993 4.99972 8.63268 4.99972 8.5C4.99972 8.36732 5.05243 8.24007 5.14625 8.14625C5.24007 8.05243 5.36732 7.99972 5.5 7.99972C5.63268 7.99972 5.75993 8.05243 5.85375 8.14625L7 9.29313L10.1462 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3692 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6914 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375Z" fill="#2FB551" />
                                </Icon>
                            </Flex>
                        </Flex>
                    </Flex>
                    <Box fontWeight={700} fontSize={{ base: '28px', lg: '32px' }} mb={'6px'} noOfLines={1} title={nftInformation?.name}>{nftInformation?.name || `#${nftInformation?.tokenId}`}</Box>
                    <Flex justify={'space-between'} mb={'24px'}>
                        <Flex align={'center'} justify={'start'}>
                            <Box fontSize={{ base: '12px', lg: '16px' }} fontWeight={400} color={'#808489'} >{intl.formatMessage({ id: 'NFT.OWNER.BY' })}</Box>
                            <Box cursor={'pointer'} onClick={() => handleCopy(nftInformation?.owner?.[0]!)} ml={'8px'}>{nftInformation?.owner?.some(owner => owner?.toLowerCase() === userData?.walletAddress?.toLowerCase() as string) ? intl.formatMessage({ id: 'NFT.YOU' }) : minify(nftInformation?.owner[0] as string, 4, 6)}</Box>
                        </Flex>
                    </Flex>
                    <Flex>
                        <ActionMenu />
                        {
                            isLogin && <Box
                                ml={'12px'}
                                borderRadius={'50%'}
                            >
                                <Box
                                    as={'button'}
                                    color='#FFFFFF'
                                    cursor={'pointer'}
                                    rounded="6px"
                                    fontSize={{ base: '16px', lg: '18px' }}
                                    fontWeight='600'
                                    transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
                                    bg={'linear-gradient(90deg, #29E9DD, #F99FAB)'}
                                    p={'2px'}
                                    height={{ base: '48px', lg: '48px' }}
                                    _hover={{ bg: 'linear-gradient(90deg, #F99FAB, #29E9DD)', transition: 'all 0.2s cubic-bezier(.08,.52,.52,1)' }}
                                    _focus={{
                                        boxShadow:
                                            '0 0 1px 2px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .15)',
                                    }}
                                    _active={{
                                        bg: '#dddfe2',
                                        transform: 'scale(0.98)',
                                        borderColor: '#bec3c9',
                                    }}
                                    onClick={syncCollection}
                                >
                                    <Box h={'100%'} bg="#131619" rounded="4px" display={'flex'} justifyContent={'start'} alignItems={'center'} gap={'8px'}>

                                        <Box px={{ base: '8px', lg: '24px' }} style={{ textWrap: 'nowrap' }} display='flex' alignItems={'center'} h={'100%'} textAlign={'center'} bgColor={'#FFFFFF0A'}>
                                            <Box w={{ base: '14px', lg: '18px' }} h={{ base: '14px', lg: '18px' }} mr={{ base: '8px', lg: '12px' }}>
                                                <Icon display={'block'} w={{ base: '14px', lg: '18px' }} h={{ base: '14px', lg: '18px' }} viewBox="0 0 18 18" fill="none" color="#808489">
                                                    <path d="M15.5316 14.4722C15.6715 14.6127 15.7501 14.803 15.7501 15.0014C15.7501 15.1998 15.6715 15.3901 15.5316 15.5306C15.4294 15.6309 13.0144 18 9 18C5.49469 18 2.95031 15.9 1.5 14.2641V16.5C1.5 16.6989 1.42098 16.8897 1.28033 17.0303C1.13968 17.171 0.948912 17.25 0.75 17.25C0.551088 17.25 0.360322 17.171 0.21967 17.0303C0.0790178 16.8897 0 16.6989 0 16.5V12C0 11.8011 0.0790178 11.6103 0.21967 11.4697C0.360322 11.329 0.551088 11.25 0.75 11.25H5.25C5.44891 11.25 5.63968 11.329 5.78033 11.4697C5.92098 11.6103 6 11.8011 6 12C6 12.1989 5.92098 12.3897 5.78033 12.5303C5.63968 12.671 5.44891 12.75 5.25 12.75H2.1975C3.3525 14.1891 5.71875 16.5 9 16.5C12.375 16.5 14.4506 14.4881 14.4713 14.4675C14.6125 14.3276 14.8035 14.2495 15.0024 14.2503C15.2012 14.2512 15.3915 14.331 15.5316 14.4722ZM17.25 0.75C17.0511 0.75 16.8603 0.829018 16.7197 0.96967C16.579 1.11032 16.5 1.30109 16.5 1.5V3.73594C15.0497 2.1 12.5053 0 9 0C4.98563 0 2.57063 2.36906 2.46938 2.46938C2.3284 2.60986 2.249 2.80059 2.24865 2.99961C2.24829 3.19863 2.32702 3.38965 2.4675 3.53063C2.60798 3.6716 2.79871 3.751 2.99774 3.75135C3.19676 3.75171 3.38777 3.67298 3.52875 3.5325C3.54938 3.51187 5.625 1.5 9 1.5C12.2812 1.5 14.6475 3.81094 15.8025 5.25H12.75C12.5511 5.25 12.3603 5.32902 12.2197 5.46967C12.079 5.61032 12 5.80109 12 6C12 6.19891 12.079 6.38968 12.2197 6.53033C12.3603 6.67098 12.5511 6.75 12.75 6.75H17.25C17.4489 6.75 17.6397 6.67098 17.7803 6.53033C17.921 6.38968 18 6.19891 18 6V1.5C18 1.30109 17.921 1.11032 17.7803 0.96967C17.6397 0.829018 17.4489 0.75 17.25 0.75Z" fill="white" />
                                                </Icon>
                                            </Box>
                                            {intl.formatMessage({ id: 'PROFILE.SYNC' })}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        }
                    </Flex>

                    <Box height={'1px'} backgroundColor={'#27282A'} my={{ lg: '32px', base: '24px' }}></Box>
                    {moment().isBefore(moment(nftInformation?.setting?.endTime)) &&
                        <Box mb={{ base: '24px', lg: '32px' }}>
                            <Box mb={'8px'} fontSize={{ base: '12px', lg: '16px' }} fontWeight={400} color={'#808489'} >{intl.formatMessage({ id: 'NFT.CURRENT.PRICE' })}</Box>
                            <Flex mb={'6px'}>
                                <Box fontWeight={700} fontSize={{ base: '28px', lg: '32px' }}>{nftInformation?.setting?.price} {nftInformation?.setting?.currency}</Box>
                                {/* <Flex color={'#808489'} ml={'8px'} pb={'8px'} align={'end'} fontWeight={400} fontSize={{ base: '28px', lg: '16px' }}>{nftInformation?.setting?.price ? (nftInformation?.setting?.price * priceUsd)?.toFixed(4) : 0} $</Flex> */}
                            </Flex>
                        </Box>
                    }
                    {moment().isBefore(moment(nftInformation?.setting?.endTime)) && nftInformation?.owner?.[0]?.toLocaleLowerCase() !== userData?.walletAddress?.toLocaleLowerCase() &&
                        <FormControl mb={{ base: '24px', lg: '32px' }} isRequired>
                            <FormLabel mb={'8px'} fontSize={{ base: '12px', lg: '16px' }} fontWeight={400} color={'#808489'} >
                                {intl.formatMessage({ id: 'NFT.REFERRER_CODE' })}
                            </FormLabel>
                            <Input
                                disabled={Boolean(userData?.appliedCode)}
                                pl={'16px'} border={'none'} focusBorderColor='#29E9DD' h='48px' backgroundColor={'#FFFFFF0A'}
                                name='referralCode'
                                type='text'
                                placeholder={intl.formatMessage({ id: 'NFT.REFERRER_CODE.PLACEHOLDER' })}
                                value={referralCode}
                                onChange={(e) => setReferralCode(e.target.value)}
                            />
                        </FormControl>
                    }
                    {MARKETPLACE_SUPPORT_NETWORK?.includes(network!) && nftInformation?.owner?.some(owner => owner?.toLowerCase() === userData?.walletAddress?.toLowerCase() as string) &&
                        <Box mb={{ base: '24px', lg: '32px' }}>
                            <Button
                                onClick={moment().isBetween(moment(nftInformation?.setting?.startTime), moment(nftInformation?.setting?.endTime)) ? (!loaddingCancelListing ? handleCancelListing : () => { }) : (!loaddingListing ? handleListing : () => { })}
                                w={'100%'}
                                as={'button'}
                                color='#FFFFFF'
                                cursor={'pointer'}
                                rounded="6px"
                                fontSize={{ base: '18px', lg: '20px' }}
                                fontWeight='600'
                                transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
                                bg={'linear-gradient(90deg, #29E9DD, #F99FAB)'}
                                p={'2px'}
                                height={{ base: '48px', lg: '56px' }}
                                _hover={{ bg: 'linear-gradient(90deg, #F99FAB, #29E9DD)', transition: 'all 0.2s cubic-bezier(.08,.52,.52,1)' }}

                                _active={{
                                    bg: '#dddfe2',
                                    transform: 'scale(0.98)',
                                    borderColor: '#bec3c9',
                                }}
                                isDisabled={loaddingCancelListing || loaddingListing || (highestStaking?.status === STAKING_STATUS.UNSTAKING || highestStaking?.status === STAKING_STATUS.STAKED)}
                                opacity={(loaddingCancelListing || loaddingListing) ? '30%' : ''}
                            >
                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} w={'100%'} h={'100%'} bg="#131619" rounded="4px">
                                    <Box w={'100%'} color={'#FFFFFF'} style={{ textWrap: 'nowrap' }} display='flex' alignItems={'center'} justifyContent={'center'} px={{ base: '12px', lg: '24px' }} h={'100%'} textAlign={'center'} bgColor={'#FFFFFF0A'}>
                                        {
                                            highestStaking && (highestStaking?.status === STAKING_STATUS.UNSTAKING || highestStaking?.status === STAKING_STATUS.STAKED) ?
                                                intl.formatMessage({ id: 'NFT.LIST.STAKING' })
                                                :
                                                moment().isBetween(moment(nftInformation?.setting?.startTime), moment(nftInformation?.setting?.endTime)) ? intl.formatMessage({ id: 'NFT.LIST.CANCEL' }) : intl.formatMessage({ id: 'NFT.LIST.FOR.SALE' })
                                        }
                                        {(loaddingListing || loaddingCancelListing) && <CircularProgress pl={'10px'} size={'20px'} isIndeterminate color='green.700' />}
                                    </Box>
                                </Box>
                            </Button>
                        </Box>
                    }
                    {MARKETPLACE_SUPPORT_NETWORK?.includes(network!) && !nftInformation?.owner?.some(owner => owner?.toLowerCase() === userData?.walletAddress?.toLowerCase() as string) &&
                        <Box mb={{ base: '24px', lg: '32px' }}>
                            <Button
                                onClick={(moment().isBefore(moment(nftInformation?.setting?.endTime)) && !loadingBuying) ? handleLogicOpenBuyModal : () => { }}
                                w={'100%'}
                                as={'button'}
                                color='#FFFFFF'
                                cursor={'pointer'}
                                rounded="6px"
                                fontSize={{ base: '18px', lg: '20px' }}
                                fontWeight='600'
                                transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
                                bg={'linear-gradient(90deg, #29E9DD, #F99FAB)'}
                                p={'2px'}
                                height={{ base: '48px', lg: '56px' }}
                                _hover={{ bg: 'linear-gradient(90deg, #F99FAB, #29E9DD)', transition: 'all 0.2s cubic-bezier(.08,.52,.52,1)' }}

                                _active={{
                                    bg: '#dddfe2',
                                    transform: 'scale(0.98)',
                                    borderColor: '#bec3c9',
                                }}
                                opacity={(!nftInformation?.setting || loadingBuying || !moment().isBefore(moment(nftInformation?.setting?.endTime))) ? '30%' : ''}

                            >
                                <Box display={'flex'} justifyContent={'center'} alignItems={'center'} w={'100%'} h={'100%'} bg="#131619" rounded="4px">
                                    <Box w={'100%'} color={'#FFFFFF'} style={{ textWrap: 'nowrap' }} display='flex' alignItems={'center'} justifyContent={'center'} px={{ base: '12px', lg: '24px' }} h={'100%'} textAlign={'center'} bgColor={'#FFFFFF0A'}>
                                        {loadingBuying ? intl.formatMessage({ id: 'NFT.BUYING' }) : intl.formatMessage({ id: 'NFT.BUY.NOW' })}
                                        {loadingBuying && <CircularProgress pl={'10px'} size={'20px'} isIndeterminate color='green.700' />}
                                    </Box>
                                </Box>
                            </Button>
                        </Box>
                    }
                    {nftInformation && !nftInformation?.owner?.some(owner => owner?.toLowerCase() === userData?.walletAddress?.toLowerCase() as string) && <>{
                        !nftInformation?.setting ?
                            <Box textAlign={'center'} color={'#808489'}>{intl.formatMessage({ id: 'NFT.REASON.NOT_LISTED' })}</Box> : <>{
                                !moment().isBefore(moment(nftInformation?.setting?.endTime)) ?
                                    <Box textAlign={'center'} color={'#808489'}>{intl.formatMessage({ id: 'NFT.REASON.PASSED_LISTING_PERIOD' })}</Box> :
                                    <Box></Box>
                            }
                            </>

                    }</>
                    }
                </Box>
            </Flex>
            <Flex w={'100%'} flexWrap={'wrap'}>
                <Box w={{ lg: '70%', base: '100%' }}>
                    <Box borderRadius={'6px'} backgroundColor={'#FFFFFF0A'} p={{ base: '24px', lg: '40px' }} mb={{ base: '16px', lg: '40px' }}>
                        <Text fontSize={{ lg: '20px', base: '18px' }}>{intl.formatMessage({ id: 'NFT.DESCRIPTION' })}</Text>
                        <Box height={'1px'} backgroundColor={'#27282A'} my={{ lg: '24px', base: '18px' }}></Box>
                        <Box >
                            <Flex mb={{ base: '16px', lg: '16px' }}>
                                <Box color={'#808489'}>{intl.formatMessage({ id: 'NFT.BY' }, { name: <span onClick={() => handleCopy(nftInformation?.collection?.creator?.walletAddress as string)} style={{ cursor: 'pointer', fontSize: '16px', color: '#FFFFFF' }} >{nftInformation?.collection?.creator?.fullname ? nftInformation?.collection?.creator?.fullname : minify(nftInformation?.collection?.creator?.walletAddress as string, 6, 4)}</span> })}</Box>
                            </Flex>
                            <Text onClick={() => handleCopy(nftInformation?.owner?.[0] as string)} fontSize={{ lg: '16px', base: '16px' }}>
                                {nftInformation?.description}
                            </Text>
                        </Box>
                    </Box>
                    <Box borderRadius={'6px'} backgroundColor={'#FFFFFF0A'} p={{ base: '24px', lg: '40px' }} mb={{ base: '16px', lg: '40px' }}>
                        <Flex align={'center'}>
                            <Text overflow={'hidden'} textOverflow={'ellipsis'} whiteSpace={'nowrap'} fontSize={{ lg: '20px', base: '18px' }}>
                                {intl.formatMessage({ id: 'NFT.ABOUT' }, { name: nftInformation?.collection?.name })}
                            </Text>
                            <Box ml={'8px'}>
                                <Icon h={'14px'} w={'14px'} viewBox='0 0 14 14' fill="none" color='white'>
                                    <path d="M14.1163 6.42625C13.8806 6.18 13.6369 5.92625 13.545 5.70312C13.46 5.49875 13.455 5.16 13.45 4.83187C13.4406 4.22187 13.4306 3.53062 12.95 3.05C12.4694 2.56937 11.7781 2.55937 11.1681 2.55C10.84 2.545 10.5013 2.54 10.2969 2.455C10.0744 2.36312 9.82 2.11937 9.57375 1.88375C9.1425 1.46937 8.6525 1 8 1C7.3475 1 6.85812 1.46937 6.42625 1.88375C6.18 2.11937 5.92625 2.36312 5.70312 2.455C5.5 2.54 5.16 2.545 4.83187 2.55C4.22187 2.55937 3.53062 2.56937 3.05 3.05C2.56937 3.53062 2.5625 4.22187 2.55 4.83187C2.545 5.16 2.54 5.49875 2.455 5.70312C2.36312 5.92562 2.11937 6.18 1.88375 6.42625C1.46937 6.8575 1 7.3475 1 8C1 8.6525 1.46937 9.14187 1.88375 9.57375C2.11937 9.82 2.36312 10.0737 2.455 10.2969C2.54 10.5013 2.545 10.84 2.55 11.1681C2.55937 11.7781 2.56937 12.4694 3.05 12.95C3.53062 13.4306 4.22187 13.4406 4.83187 13.45C5.16 13.455 5.49875 13.46 5.70312 13.545C5.92562 13.6369 6.18 13.8806 6.42625 14.1163C6.8575 14.5306 7.3475 15 8 15C8.6525 15 9.14187 14.5306 9.57375 14.1163C9.82 13.8806 10.0737 13.6369 10.2969 13.545C10.5013 13.46 10.84 13.455 11.1681 13.45C11.7781 13.4406 12.4694 13.4306 12.95 12.95C13.4306 12.4694 13.4406 11.7781 13.45 11.1681C13.455 10.84 13.46 10.5013 13.545 10.2969C13.6369 10.0744 13.8806 9.82 14.1163 9.57375C14.5306 9.1425 15 8.6525 15 8C15 7.3475 14.5306 6.85812 14.1163 6.42625ZM10.8538 6.85375L7.35375 10.3538C7.30731 10.4002 7.25217 10.4371 7.19147 10.4623C7.13077 10.4874 7.06571 10.5004 7 10.5004C6.93429 10.5004 6.86923 10.4874 6.80853 10.4623C6.74783 10.4371 6.69269 10.4002 6.64625 10.3538L5.14625 8.85375C5.05243 8.75993 4.99972 8.63268 4.99972 8.5C4.99972 8.36732 5.05243 8.24007 5.14625 8.14625C5.24007 8.05243 5.36732 7.99972 5.5 7.99972C5.63268 7.99972 5.75993 8.05243 5.85375 8.14625L7 9.29313L10.1462 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3692 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6914 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375Z" fill="#2FB551" />
                                </Icon>
                            </Box>
                        </Flex>
                        <Box height={'1px'} backgroundColor={'#27282A'} my={{ lg: '24px', base: '18px' }}></Box>
                        <Box >
                            {nftInformation?.collection?.description}
                        </Box>
                    </Box>
                    <Box borderRadius={'6px'} backgroundColor={'#FFFFFF0A'} p={{ base: '24px', lg: '40px' }}>
                        <Text fontSize={{ lg: '20px', base: '18px' }}>{intl.formatMessage({ id: 'NFT.DETAILS' })}</Text>
                        <Box height={'1px'} backgroundColor={'#27282A'} my={{ lg: '24px', base: '18px' }}></Box>
                        <Flex justify={'space-between'}>
                            <Box w={{ lg: '50%', base: '50%' }}>
                                <Box color={'#808489'} fontWeight={400} fontSize={'16px'} mb={{ base: '12px', lg: '16px' }}>{intl.formatMessage({ id: 'NFT.CONTRACT.ADDRESS' })}</Box>
                                <Box color={'#808489'} fontWeight={400} fontSize={'16px'} mb={{ base: '12px', lg: '16px' }}>{intl.formatMessage({ id: 'NFT.TOKEN.ID' })}</Box>
                                <Box color={'#808489'} fontWeight={400} fontSize={'16px'} mb={{ base: '12px', lg: '16px' }}>{intl.formatMessage({ id: 'NFT.TOKEN.STANDARD' })}</Box>
                                <Box color={'#808489'} fontWeight={400} fontSize={'16px'} mb={{ base: '12px', lg: '16px' }}>{intl.formatMessage({ id: 'NFT.CHAIN' })}</Box>
                                {nftInformation?.updatedAt && <Box color={'#808489'} fontWeight={400} fontSize={'16px'}>{intl.formatMessage({ id: 'NFT.LAST.UPDATED' })}</Box>}
                            </Box>
                            <Box w={{ lg: '50%', base: '50%' }}>
                                <Box onClick={() => handleCopy(nftInformation?.contractAddress as string)} cursor={'pointer'} color={'#29E9DD'} mb={{ base: '12px', lg: '16px' }} textAlign={'end'}>{minify(nftInformation?.contractAddress as string, 6, 4)}</Box>
                                <Box mb={{ base: '12px', lg: '16px' }} textAlign={'end'}>{nftInformation?.tokenId}</Box>
                                <Box mb={{ base: '12px', lg: '16px' }} textAlign={'end'}>{nftInformation?.tokenStandard}</Box>
                                <Box mb={{ base: '12px', lg: '16px' }} textAlign={'end'}>{nftInformation?.collection?.network}</Box>
                                {nftInformation?.updatedAt && <Box textAlign={'end'}>{formatDistance(parseISO(nftInformation?.updatedAt as string), new Date(), { addSuffix: true, locale: localeMap[selectedLang] })}</Box>}
                            </Box>
                        </Flex>
                    </Box>

                </Box>
                <Box w={{ lg: '30%', base: '100%' }}>

                </Box>
            </Flex>
            {nftInformation?.owner?.some(owner => owner?.toLowerCase() === userData?.walletAddress?.toLowerCase() as string) && moreNftForCollection && moreNftForCollection?.filter(nft => nft?.tokenId !== (tokenId as string))?.length > 0 &&
                <MoreNft moreNftForCollection={moreNftForCollection?.filter(nft => nft?.tokenId !== (tokenId as string))} />}
            {
                openModalListForSale && <ListForSaleModal priceUsd={priceUsd} handleReloadData={handleReloadData} nftInformation={nftInformation} network={network as string} openModalListForSale={openModalListForSale} setOpenModalListForSale={setOpenModalListForSale} onCloseModalListForSale={onCloseModalListForSale} />
            }
            {
                openModalBuyNft && <BuyNftModal nftInformation={nftInformation} pricePurchase={pricePurchase} openModalBuyNft={openModalBuyNft} onCloseModalBuyNft={onCloseModalBuyNft} />
            }
        </Container>
    )
}
